import React, { useState, useEffect } from 'react';

const LIVE_BADGE_COLORS = {
  LIVE: '#34C759',
  PARTIAL_COVERAGE: '#FF9F0A',
  DEGRADED: '#FF9F0A',
  OFFLINE: '#FF3B30',
  NO_LIVE_SOURCES: '#FF3B30',
};

export default function TopBar({ timestamp, sensorCount, totalEvents, regionsOnline, regionsTotal, onRefresh, sourceHealth, tempUnit, onToggleUnit, onSwitchAgent, onSwitchToShow, onSwitchToVega, onSwitchToAtlas, onSwitchToCrew, onSwitchToQuill, onSwitchToShowRoom, onSwitchToKarbon, onOpenForecast, monitoringState = 'LIVE', sensorReadiness }) {
  const [clock, setClock] = useState('');

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      setClock(
        now.getUTCHours().toString().padStart(2, '0') + ':' +
        now.getUTCMinutes().toString().padStart(2, '0') + ':' +
        now.getUTCSeconds().toString().padStart(2, '0')
      );
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const degraded = sourceHealth?.degraded?.length || 0;

  const readinessState = sensorReadiness?.state || '';
  const liveState = readinessState === 'NO_LIVE_SOURCES'
    ? 'NO SOURCES'
    : (monitoringState || 'LIVE').replace(/_/g, ' ');
  const badgeColor = LIVE_BADGE_COLORS[readinessState] || LIVE_BADGE_COLORS[monitoringState] || LIVE_BADGE_COLORS.LIVE;

  return (
    <div className="topbar" data-testid="topbar">
      <div className="topbar-dot"></div>
      <span className="topbar-logo">Nova</span>
      <div className="topbar-sep"></div>
      <span className="topbar-sub">WEATHER INTELLIGENCE</span>
      <div className="topbar-spacer"></div>
      <span className="topbar-regions" data-testid="topbar-regions">{regionsOnline}/{regionsTotal} REGIONS</span>
      {sensorCount > 0 && <span className="topbar-sensors" data-testid="topbar-sensors">{sensorCount} signals</span>}
      {degraded > 0 && <span className="topbar-degraded" data-testid="topbar-degraded">{degraded} DEGRADED</span>}
      <button className="unit-toggle" onClick={onToggleUnit} data-testid="unit-toggle" title={`Switch to ${tempUnit === 'F' ? 'Celsius' : 'Fahrenheit'}`}>
        {tempUnit === 'F' ? '\u00B0F' : '\u00B0C'}
      </button>
      <button className="topbar-refresh" onClick={onRefresh} data-testid="topbar-refresh">REFRESH</button>
      <span className="topbar-clock" data-testid="topbar-clock">{clock}</span>
      <span className="topbar-utc">UTC</span>
      <span className="topbar-live" data-testid="topbar-live" style={{ color: badgeColor, borderColor: `${badgeColor}40` }}>
        {liveState}
      </span>
      <div className="topbar-agent-desktop">
        {onOpenForecast && <button className="orion-switch-nova" onClick={onOpenForecast} data-testid="open-forecast-btn" style={{ color: '#7ecfc0', borderColor: '#7ecfc040' }}>FORECAST</button>}
        {onSwitchAgent && <button className="orion-switch-nova" onClick={onSwitchAgent} data-testid="switch-to-orion-btn">ORION</button>}
        {onSwitchToVega && <button className="orion-switch-nova" onClick={onSwitchToVega} data-testid="switch-to-vega-btn" style={{ color: '#6366F1', borderColor: '#6366F130' }}>VEGA</button>}
        {onSwitchToAtlas && <button className="orion-switch-nova" onClick={onSwitchToAtlas} data-testid="switch-to-atlas-btn" style={{ color: '#059669', borderColor: '#05966930' }}>ATLAS</button>}
        {onSwitchToKarbon && <button className="orion-switch-nova" onClick={onSwitchToKarbon} data-testid="switch-to-karbon-btn" style={{ color: '#00e5b0', borderColor: '#00e5b040' }}>KARBON</button>}
        {onSwitchToShow && <button className="orion-switch-nova" onClick={onSwitchToShow} data-testid="switch-to-show-btn" style={{ color: '#e8e8e8', borderColor: '#e8e8e830' }}>SHOW</button>}
        {onSwitchToCrew && <button className="orion-switch-nova" onClick={onSwitchToCrew} data-testid="switch-to-crew-btn" style={{ color: '#4de2c0', borderColor: '#4de2c040' }}>CREW</button>}
        {onSwitchToQuill && <button className="orion-switch-nova" onClick={onSwitchToQuill} data-testid="switch-to-quill-btn" style={{ color: '#d4a574', borderColor: '#d4a57440' }}>QUILL</button>}
        {onSwitchToShowRoom && <button className="orion-switch-nova" onClick={onSwitchToShowRoom} data-testid="switch-to-showroom-btn" style={{ color: '#f472b6', borderColor: '#f472b640' }}>SHOW ROOM</button>}
      </div>
    </div>
  );
}
